import { useTranslation } from "react-i18next";

import { Dialog } from "./Dialog";
import {
    RootStateKind,
    ScanSubStateKind,
    useRootState
} from "./state/StateProvider";
import * as svg from "./svg";
import { ActionKind } from "../types/Action";
import { CheckoutError } from "../types/Cart";

export const CheckoutDialog = () => {
    const { t } = useTranslation();

    const { state, dispatch } = useRootState(RootStateKind.Scan);

    const { subState } = state;

    const onCancel = () => {
        dispatch({ kind: ActionKind.HideCheckoutDialog });
    };

    const ConfirmCartDialog = () => (
        <Dialog
            dataTestId="confirmCartDialog"
            image={svg.confirmCart}
            title={t("confirmCart")}
            primaryButton={{
                title: t("toPayment"),
                action: () => {
                    dispatch({ kind: ActionKind.StartPayment });
                }
            }}
            secondaryButton={{ title: t("back"), action: onCancel }}
            onBackgroundClick={onCancel}
        />
    );

    const UnappliedCouponDialog = () => (
        <Dialog
            dataTestId="unappliedCouponDialog"
            image={svg.productNotFound}
            title={t("unappliedCoupon.title")}
            primaryButton={{
                title: t("toPayment"),
                action: () => {
                    dispatch({ kind: ActionKind.ConfirmUnappliedCoupon });
                }
            }}
            secondaryButton={{ title: t("back"), action: onCancel }}
            onBackgroundClick={onCancel}
        >
            {t("unappliedCoupon.description")}
        </Dialog>
    );

    const CartCheckDialog = () => (
        <Dialog
            dataTestId="cartCheckDialog"
            image={svg.productNotFound}
            title={t("cartCheckTriggered")}
        />
    );

    const ProcessingPaymentDialog = () => (
        <Dialog image={svg.pos} title={t("interactWithTerminal")} />
    );

    const PaymentFailedDialog = ({ error }: { error: CheckoutError }) => {
        const errorKey = `checkoutError.${error.case}`;
        const title = t([
            `${errorKey}.title`,
            errorKey,
            "checkoutError.default"
        ]);
        const description = t(`${errorKey}.description`, { defaultValue: "" });

        return (
            <Dialog
                dataTestId="paymentFailedDialog"
                image={svg.productNotFound}
                title={title}
                primaryButton={{
                    title: t("tryAgain"),
                    action: () => {
                        dispatch({ kind: ActionKind.StartPayment });
                    }
                }}
                secondaryButton={{ title: t("back"), action: onCancel }}
            >
                {description}
            </Dialog>
        );
    };

    switch (subState.kind) {
        case ScanSubStateKind.CartCheck:
            return <CartCheckDialog />;

        case ScanSubStateKind.UnappliedCoupon:
            return <UnappliedCouponDialog />;

        case ScanSubStateKind.CheckingOut:
            return <ConfirmCartDialog />;

        case ScanSubStateKind.ProcessPayment:
            return <ProcessingPaymentDialog />;

        case ScanSubStateKind.CheckoutError:
            return <PaymentFailedDialog error={subState.reason} />;

        default:
            return null;
    }
};
